import axios from "axios";

// ============= CARDCOM CONFIGURATIONS =============

export const getCardcomConfigs = () => async (dispatch) => {
  const res = await axios.get("/api/cardcom/configs");
  return res.data;
};

export const createCardcomConfig = (config) => async (dispatch) => {
  const res = await axios.post("/api/cardcom/configs", config);
  return res.data;
};

export const updateCardcomConfig = (id, config) => async (dispatch) => {
  const res = await axios.put(`/api/cardcom/configs/${id}`, config);
  return res.data;
};

// → [{ key, name }] (key = stored value, name = Hebrew label). An older server returns plain
// keys — those are turned into { key, name: key } so callers always get one shape.
export const getSchoolerCourses = () => async (dispatch) => {
  const res = await axios.get("/api/cardcom/courses");
  return (res.data || []).map((c) => (typeof c === "string" ? { key: c, name: c } : c));
};

export const deleteCardcomConfig = (id) => async (dispatch) => {
  const res = await axios.delete(`/api/cardcom/configs/${id}`);
  return res.data;
};
